import React, { useState } from 'react';

export const LandingFinal = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };
  return (
    <div className="relative min-h-screen w-full overflow-x-hidden bg-gradient-to-b from-[#070718] via-[#08081e] to-[#0D0C2A]">
      {/* Background Elements */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Desktop positioning */}
        <img className="absolute right-0 top-[109px] z-0 w-auto h-auto max-w-[255px] md:block" src="/assets/purple-planet.png" alt="Purple planet decoration" />
        <img className="absolute left-0 top-[136px] z-1 w-auto h-auto max-w-[357px] md:block" src="/assets/bg-planet-1.png" alt="Background planet decoration" />
        <img className="absolute right-[-100px] top-[743px] z-1 w-auto h-auto max-w-[377px] md:block" src="/assets/bg-planet-2.png" alt="Background planet decoration" />
        
        {/* Mobile positioning - move elements behind content */}
        <img 
          className="absolute left-[10%] md:top-[850px] top-[950px] md:z-20 z-0 w-auto h-auto max-w-[292px] max-md:opacity-40" 
          src="/assets/Rocket.png" 
          alt="Rocket decoration" 
        />
        <img 
          className="absolute left-[-63px] md:top-[743px] top-[1043px] md:z-20 z-0 w-auto h-auto max-w-[254px] max-md:opacity-50" 
          src="/assets/green-planet.png" 
          alt="Green planet decoration" 
        />
      </div>
      
      {/* Dark Background Shape for Lower Sections */}
      <div className="absolute left-0 top-[min(100vh,1013px)] z-1 h-[min(150vh,1353px)] w-full bg-[#050719]"></div>

      <div className="relative z-10 mx-auto max-w-[1408px] px-4 sm:px-6 lg:px-8">
        {/* Navigation */}
        <nav className="relative z-10 flex items-center justify-between py-8 md:py-12">
          <div className="flex items-center">
            <img src="/assets/RocketScanner_Horizontal 1.png" alt="RocketScanner Logo" className="h-10 w-auto md:h-12" />
          </div>
          
          <div className="hidden md:flex items-center space-x-8">
            <a href="/" className="text-white font-bold hover:text-[#AAA1FD] transition-colors">Home</a>
            <a href="/pricing" className="text-white font-bold hover:text-[#AAA1FD] transition-colors">Pricing</a>
            <a href="/about" className="text-white font-bold hover:text-[#AAA1FD] transition-colors">About Us</a>
            <a href="/contact" className="text-white font-bold hover:text-[#AAA1FD] transition-colors">Contact</a>
          </div>
          
          <div className="hidden md:flex gap-3">
            <a 
              href="/register" 
              className="rounded-full bg-[#FFA17A] px-6 py-2.5 text-sm font-bold text-[#0B0F19] shadow-md border-t border-[#FFCBB6] hover:bg-[#FFCBB6] transition-colors w-28 text-center"
            >
              Sign Up
            </a>
            <a 
              href="/login" 
              className="rounded-full bg-[#134448] px-6 py-2.5 text-sm font-bold text-[#1ABC9D] shadow-md hover:bg-[#0D3135] transition-colors w-28 text-center"
            >
              Login
            </a>
          </div>
        </nav>

        {/* Main Content / Hero Section */}
        <div className="relative z-10 flex flex-col-reverse md:flex-row justify-between items-center gap-8 md:gap-12 pt-8 md:pt-16">
          <div className="w-full md:w-2/3 flex flex-col items-center md:items-start text-center md:text-left gap-6 md:gap-8">
            <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-semibold text-white leading-tight">
              AI-powered cataloging made easy
            </h1>
            <p className="text-xl sm:text-2xl md:text-3xl text-[#D4D1EC] font-normal max-w-3xl">
              AI-powered tools for faster cataloging, barcode scanning, and image recognition — built for auction and resale teams.
            </p>
            <div className="flex flex-col sm:flex-row gap-4 sm:gap-6 w-full sm:w-auto">
              <a 
                href="/register" 
                className="flex items-center justify-center px-8 py-3 rounded-full bg-[#1DC9A0] font-bold text-[#0B0F19] shadow-md border-t border-[#66E0C2] hover:bg-[#66E0C2] transition-colors"
              >
                Get Started
              </a>
              <a 
                href="/about" 
                className="flex items-center justify-center text-white font-bold hover:text-[#AAA1FD] transition-colors"
              >
                Learn More
                <svg className="ml-2" width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M13.5 1L24 11M24 11L13.5 21M24 11H1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                </svg>
              </a>
            </div>
          </div>
          <div className="w-full md:w-1/3 max-w-[425px]">
            <img 
              src="/assets/iphone.png" 
              alt="RocketScanner App on iPhone" 
              className="w-full h-auto object-contain filter drop-shadow-xl"
            />
          </div>
        </div>
      </div>

      {/* Features Section */}
      <div className="relative z-10 mt-40 md:mt-60 py-20 px-4 sm:px-6 lg:px-8">
        <div className="mx-auto max-w-[1200px]">
          <div className="text-center max-w-3xl mx-auto mb-16 md:mb-24">
            <h2 className="uppercase text-[#AAA1FD] font-bold text-sm md:text-base tracking-widest mb-2">
              FASTER INVENTORY MANAGEMENT
            </h2>
            <h3 className="text-white text-2xl md:text-3xl lg:text-4xl font-semibold mb-4">
              Everything you need to catalog your items
            </h3>
            <p className="text-white text-base md:text-lg leading-relaxed">
              RocketScanner combines cutting-edge technology with user-friendly interfaces to make inventory management effortless and efficient.
            </p>
          </div>
          
          <div className="grid grid-cols-1 md:grid-cols-2 gap-12 md:gap-16 max-w-6xl mx-auto">
            {/* Feature Item 1 */}
            <div className="flex flex-col md:flex-row items-center md:items-start text-center md:text-left gap-6">
              <div className="flex-shrink-0 w-10 h-10 bg-[#1DC9A0] rounded-md flex items-center justify-center">
                <img src="/assets/Feature Icon Barcode.svg" alt="Barcode icon" className="w-6 h-6" />
              </div>
              <div>
                <h4 className="text-white text-lg font-bold mb-3">UPC Barcode Scanning</h4>
                <p className="text-[#D4D1EC] text-base leading-relaxed">
                  Quickly scan UPC codes to automatically populate item details from our extensive database, saving time and reducing errors.
                </p>
              </div>
            </div>
            
            {/* Feature Item 2 */}
            <div className="flex flex-col md:flex-row items-center md:items-start text-center md:text-left gap-6">
              <div className="flex-shrink-0 w-10 h-10 bg-[#1DC9A0] rounded-md flex items-center justify-center">
                <img src="/assets/Feature Icon AI.svg" alt="AI icon" className="w-6 h-6" />
              </div>
              <div>
                <h4 className="text-white text-lg font-bold mb-3">AI-Powered Image Recognition</h4>
                <p className="text-[#D4D1EC] text-base leading-relaxed">
                  Let our advanced AI analyze item photos to generate detailed descriptions, identify key features, and suggest categories.
                </p>
              </div>
            </div>
            
            {/* Feature Item 3 */}
            <div className="flex flex-col md:flex-row items-center md:items-start text-center md:text-left gap-6">
              <div className="flex-shrink-0 w-10 h-10 bg-[#1DC9A0] rounded-md flex items-center justify-center">
                <img src="/assets/Feature Icon Lists.svg" alt="Lists icon" className="w-6 h-6" />
              </div>
              <div>
                <h4 className="text-white text-lg font-bold mb-3">Customizable Lists</h4>
                <p className="text-[#D4D1EC] text-base leading-relaxed">
                  Create and manage multiple inventory lists, each with its own set of items. Perfect for organizing by events, locations, or categories.
                </p>
              </div>
            </div>
            
            {/* Feature Item 4 */}
            <div className="flex flex-col md:flex-row items-center md:items-start text-center md:text-left gap-6">
              <div className="flex-shrink-0 w-10 h-10 bg-[#1DC9A0] rounded-md flex items-center justify-center">
                <img src="/assets/Feature Icon Export.svg" alt="Export icon" className="w-6 h-6" />
              </div>
              <div>
                <h4 className="text-white text-lg font-bold mb-3">Export & Share</h4>
                <p className="text-[#D4D1EC] text-base leading-relaxed">
                  Export your inventory to spreadsheets or download image collections for seamless integration with other systems and platforms.
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="relative z-10 bg-[#103B3F] py-16 md:py-24 px-4 sm:px-6 lg:px-8 mt-20 md:mt-32">
        <div className="mx-auto max-w-3xl text-center">
          <h3 className="text-white text-2xl md:text-3xl lg:text-4xl font-semibold mb-4">
            Boost your productivity today
          </h3>
          <p className="text-white text-base md:text-lg leading-relaxed mb-8">
            Join thousands of businesses that trust RocketScanner for their inventory management needs. Get started in minutes.
          </p>
          <div className="flex flex-col sm:flex-row justify-center gap-4 sm:gap-6">
            <a 
              href="/register" 
              className="flex items-center justify-center px-8 py-3 rounded-full bg-[#DE7A44] font-bold text-[#0B0F19] shadow-md border-t border-[#FFCBB6] hover:bg-[#FFA17A] transition-colors"
            >
              Get Started
            </a>
            <a 
              href="/about" 
              className="flex items-center justify-center text-white font-bold hover:text-[#AAA1FD] transition-colors"
            >
              Learn More
              <svg className="ml-2" width="25" height="22" viewBox="0 0 25 22" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M13.5 1L24 11M24 11L13.5 21M24 11H1" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </a>
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="relative z-10 px-4 sm:px-6 lg:px-8 py-8 md:py-12">
        <div className="mx-auto max-w-7xl flex flex-col sm:flex-row justify-between items-center gap-4">
          <p className="text-[#AAA1FD] text-xs">© 2025 RocketScanner. All rights reserved.</p>
          <div className="flex items-center gap-6">
            <a href="#" aria-label="YouTube" className="text-[#AAA1FD] hover:text-white transition-colors">
              <svg width="23" height="16" viewBox="0 0 23 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M22.1269 2.50624C21.8708 1.53749 21.1081 0.781241 20.1394 0.524991C18.3729 0.0499908 11.375 0.0499908 11.375 0.0499908C11.375 0.0499908 4.37708 0.0499908 2.61063 0.524991C1.64188 0.781241 0.879169 1.53749 0.623127 2.50624C0.148127 4.27499 0.148127 8.00001 0.148127 8.00001C0.148127 8.00001 0.148127 11.725 0.623127 13.4938C0.879169 14.4625 1.64188 15.2188 2.61063 15.475C4.37708 15.95 11.375 15.95 11.375 15.95C11.375 15.95 18.3729 15.95 20.1394 15.475C21.1081 15.2188 21.8708 14.4625 22.1269 13.4938C22.6019 11.725 22.6019 8.00001 22.6019 8.00001C22.6019 8.00001 22.6019 4.27499 22.1269 2.50624Z" fill="currentColor"/>
                <path d="M9.1084 11.4L15.0459 8.00001L9.1084 4.60001V11.4Z" fill="#103B3F"/>
              </svg>
            </a>
            <a href="#" aria-label="LinkedIn" className="text-[#AAA1FD] hover:text-white transition-colors">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path d="M3.297 16.0001H0.242V5.31813H3.297V16.0001ZM1.767 3.86012C0.792 3.86012 0 2.97212 0 1.93012C0 0.888125 0.792 0 1.767 0C2.745 0 3.537 0.888125 3.537 1.93012C3.537 2.97212 2.745 3.86012 1.767 3.86012ZM15.994 16.0001H12.947V10.8001C12.947 9.56213 12.922 7.98012 11.392 7.98012C9.836 7.98012 9.596 9.32713 9.596 10.7211V16.0001H6.545V5.31813H9.468V6.77613H9.514C9.934 5.93613 10.979 5.05013 12.521 5.05013C15.612 5.05013 15.998 7.26812 15.998 10.1541V16.0001H15.994Z" fill="currentColor"/>
              </svg>
            </a>
            <a href="#" aria-label="GitHub" className="text-[#AAA1FD] hover:text-white transition-colors">
              <svg width="16" height="16" viewBox="0 0 16 16" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
                <path fillRule="evenodd" clipRule="evenodd" d="M8 0C3.58 0 0 3.67531 0 8.20248C0 11.8266 2.292 14.9013 5.47 15.9857C5.87 16.0654 6.018 15.8198 6.018 15.6073C6.018 15.4158 6.008 14.7439 6.004 14.0542C3.781 14.5478 3.312 13.0968 3.312 13.0968C2.949 12.1472 2.424 11.9017 2.424 11.9017C1.697 11.3952 2.478 11.4069 2.478 11.4069C3.281 11.469 3.703 12.249 3.703 12.249C4.417 13.5034 5.576 13.1387 6.032 12.9359C6.104 12.4092 6.311 12.0445 6.54 11.8266C4.764 11.6087 2.896 10.9037 2.896 7.76783C2.896 6.87145 3.208 6.13629 3.72 5.55855C3.637 5.35735 3.363 4.52218 3.798 3.39679C3.798 3.39679 4.47 3.18033 5.998 4.22342C6.636 4.04305 7.32 3.95404 8.001 3.95006C8.68 3.95404 9.365 4.04305 10.004 4.22342C11.531 3.18033 12.202 3.39679 12.202 3.39679C12.638 4.52218 12.364 5.35735 12.281 5.55855C12.794 6.13629 13.104 6.87145 13.104 7.76783C13.104 10.9037 11.234 11.6087 9.454 11.8266C9.738 12.0915 9.994 12.605 9.994 13.3931C9.994 14.5157 9.984 15.3422 9.984 15.6073C9.984 15.8198 10.129 16.0654 10.534 15.9857C13.7112 14.8996 16 11.8249 16 8.20248C16 3.67531 12.418 0 8 0Z" fill="currentColor"/>
              </svg>
            </a>
          </div>
        </div>
      </footer>

      {/* Mobile Menu Button - Hidden on Desktop */}
      <button 
        onClick={toggleMobileMenu}
        className="fixed top-6 right-4 z-50 md:hidden bg-[#FFA17A] p-2 rounded-md"
        aria-label="Toggle menu"
      >
        <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M4 6h16M4 12h16M4 18h16" stroke="#103B3F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </button>

      {/* Mobile Menu Overlay */}
      {mobileMenuOpen && (
        <div className="fixed inset-0 z-40 bg-black bg-opacity-80 md:hidden">
          <div className="flex flex-col items-center justify-center h-full">
            <button 
              onClick={toggleMobileMenu}
              className="absolute top-6 right-4 bg-[#FFA17A] p-2 rounded-md"
              aria-label="Close menu"
            >
              <svg width="24" height="24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M6 18L18 6M6 6l12 12" stroke="#103B3F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
              </svg>
            </button>
            <div className="flex flex-col items-center gap-8">
              <a href="/" className="text-white text-xl font-bold hover:text-[#AAA1FD] transition-colors">Home</a>
              <a href="/pricing" className="text-white text-xl font-bold hover:text-[#AAA1FD] transition-colors">Pricing</a>
              <a href="/about" className="text-white text-xl font-bold hover:text-[#AAA1FD] transition-colors">About Us</a>
              <a href="/contact" className="text-white text-xl font-bold hover:text-[#AAA1FD] transition-colors">Contact</a>
              <div className="mt-4 flex flex-col gap-3 items-center">
                <a 
                  href="/register" 
                  className="rounded-full bg-[#FFA17A] px-8 py-3 text-lg font-bold text-[#0B0F19] shadow-md border-t border-[#FFCBB6] hover:bg-[#FFCBB6] transition-colors w-40 text-center"
                >
                  Sign Up
                </a>
                <a 
                  href="/login" 
                  className="rounded-full bg-[#134448] px-8 py-3 text-lg font-bold text-[#1ABC9D] shadow-md hover:bg-[#0D3135] transition-colors w-40 text-center"
                >
                  Login
                </a>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};
